import script from "./CompositeMarkdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CompositeMarkdown.vue?vue&type=script&setup=true&lang=js"

import "./CompositeMarkdown.vue?vue&type=style&index=0&id=36d4e70c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d4e70c"]])

export default __exports__